import { WrapAddressType } from '../interface/interface';

export const WrapAddress: WrapAddressType = ({ address, className }) => {
  if (!address) {
    return <div className={className}>-</div>;
  }
  const {
    firstName,
    lastName,
    specialDeliveryInstructions,
    addressLine1,
    addressLine2,
    city,
    zipCode,
    province,
  } = address;

  const addressLines = {
    address1: `${firstName ? firstName : ''} ${lastName ? lastName : ''}`,
    address2: specialDeliveryInstructions ?? '',
    address3: addressLine1 ?? '',
    address4: addressLine2 ?? '',
    address5: `${city ? `${city},` : ''} ${zipCode ? `${zipCode},` : ''} ${province ? `${province},` : ''} ${'Australia'}`,
  };

  return (
    <div className={`flex flex-wrap ${className}`}>
      <div className="break-all mr-1">
        {addressLines.address1 ? `${addressLines.address1},` : ''}
      </div>
      {addressLines.address2 ? (
        <div className="break-all mr-1">
          {addressLines.address2 ? `${addressLines.address2},` : ''}
        </div>
      ) : null}
      <div className="break-all mr-1">
        {addressLines.address3 ? `${addressLines.address3},` : ''}
      </div>
      {addressLines.address4 ? (
        <div className="break-all mr-1">
          {addressLines.address4 ? `${addressLines.address4},` : ''}
        </div>
      ) : null}
      <div className="break-words">
        {addressLines.address5 ? `${addressLines.address5}.` : ''}
      </div>
    </div>
  );
};
